import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Rotating social-proof toast that appears bottom-left every ~10s showing
// recent members who joined. Auto-hides between rotations.
export const NewMemberToast = () => {
  const [members, setMembers] = useState([]);
  const [idx, setIdx] = useState(0);
  const [visible, setVisible] = useState(false);
  const timers = useRef([]);

  useEffect(() => {
    let cancelled = false;
    axios.get(`${API}/public/recent-members`)
      .then(res => { if (!cancelled) setMembers(res.data?.members || []); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    if (members.length === 0) return;
    // Show one member once, then hide. No rotation.
    const showT = setTimeout(() => setVisible(true), 3000);
    const hideT = setTimeout(() => setVisible(false), 12000);
    return () => { clearTimeout(showT); clearTimeout(hideT); };
  }, [members]);

  if (members.length === 0) return null;
  const m = members[idx] || {};
  const location = m.city ? `${m.city}${m.state ? ', ' + m.state : ''}` : 'Australia';

  return (
    <div
      data-testid="new-member-toast"
      style={{
        position: 'fixed',
        left: 20,
        bottom: 20,
        zIndex: 9998,
        transform: visible ? 'translateY(0)' : 'translateY(140%)',
        opacity: visible ? 1 : 0,
        transition: 'transform 500ms ease, opacity 500ms ease',
        pointerEvents: visible ? 'auto' : 'none',
      }}
    >
      <div
        style={{
          background: 'white',
          borderRadius: 12,
          boxShadow: '0 10px 30px rgba(0,0,0,0.18)',
          padding: '14px 18px 14px 14px',
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          maxWidth: 340,
          border: '1px solid #e5e7eb',
        }}
      >
        <div
          style={{
            width: 40,
            height: 40,
            borderRadius: '50%',
            background: 'linear-gradient(135deg,#2563eb,#1d4ed8)',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 900,
            fontSize: 16,
            flexShrink: 0,
          }}
        >
          {(m.first_name || 'M').charAt(0).toUpperCase()}
        </div>
        <div style={{ minWidth: 0 }}>
          <div style={{ fontSize: 14, color: '#1a2332', fontWeight: 700, lineHeight: 1.3 }}>
            {m.first_name} from {location}
          </div>
          <div style={{ fontSize: 12, color: '#059669', fontWeight: 600, marginTop: 2 }}>
            <span style={{ display: 'inline-block', width: 8, height: 8, borderRadius: '50%', background: '#10b981', marginRight: 6, verticalAlign: 'middle' }}></span>
            just joined House Sharing Seniors
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewMemberToast;
